import { PublicationStatusType } from "gql/generated.ts";
import i18n from "i18next";

export const getTagPropsFromPublicationStatus = (
  status: PublicationStatusType,
) => {
  /* TODO: add "visual" for unknown mappings. Have already asked Olivier */
  switch (status) {
    case PublicationStatusType.Approved:
      return {
        visual: "success",
        children: i18n.t("core:PUBLICATION_STATUS.APPROVED"),
      };
    case PublicationStatusType.Draft:
      return {
        children: i18n.t("core:PUBLICATION_STATUS.DRAFT"),
      };
    case PublicationStatusType.NeedsApproval:
      return {
        visual: "highlight",
        children: i18n.t("core:PUBLICATION_STATUS.NEEDS_APPROVAL"),
      };
    case PublicationStatusType.Unpublished:
      return {
        children: i18n.t("core:PUBLICATION_STATUS.UNPUBLISHED"),
      };
  }
};
